module.exports = __webpack_public_path__ + "static/img/product__camera__icon.7d971f56.svg";